import { makeStyles } from '@fluentui/react-components';

export const useSubformStyles = makeStyles({
    field: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
});
